import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './includes/menu/menu.component';
import { RouterModule, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-layout',
    imports: [
        CommonModule,
        MenuComponent,
        RouterOutlet,
        RouterModule
    ],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.css'
})
export class LayoutComponent {

  /** Le bouton support etait purement decoratif : aucun gestionnaire de clic. */
  supportOpen = false

  toggleSupport(){
    this.supportOpen = !this.supportOpen
  }

  closeSupport(){
    this.supportOpen = false
  }
}
